// TODO: delete this file and directly use BulkImportStatusType.ts and update their imports
export enum BulkImportUserStatusType {
  New = 'New',
  Running = 'Running',
  Cancelled = 'Cancelled',
  Finished = 'Finished',
  Failed = 'Failed',
}
